import type { TranslationDataObject } from './service';

export type Translation = {
  language: string;
  translatedTextContent: string;
};

export const createTranslation = (translation: TranslationDataObject): Translation => ({
  language: translation.language,
  translatedTextContent: translation.translated_text_content,
});
